/**
 * Botão do bloco `cta-lead` dentro do post: abre o formulário de demo em vez
 * de navegar.
 *
 * O bloco chega no HTML do post como `<a href="/crediario">` (ver
 * `src/shared/blog/blocks/registry.ts` e `internalLinks.ts`), e o link fica lá
 * de propósito: é o link interno para a LP do cluster que o crawler e o
 * `toMarkdown.ts` enxergam, e é o que funciona sem JavaScript. No navegador,
 * o clique abre o modal de demo — tirar o leitor do post para uma LP genérica
 * no momento em que ele decidiu falar com a Fidexa perde a conversão.
 *
 * Clique com Ctrl/Cmd/Shift ou botão do meio segue o link normalmente: quem
 * pede nova aba quer a página, não o modal.
 *
 * A contagem de `cta_click` do painel do blog é feita pelo `startPostTracking`
 * (`blogAnalytics.ts`), que escuta o mesmo container — por isso aqui só há
 * `preventDefault`, nunca `stopPropagation`.
 */

export const CTA_LEAD_LINK_SELECTOR = '[data-ds-block="cta-lead"] a[href]';

export const interceptCtaLead = (
  container: HTMLElement | null,
  onOpen: () => void
): (() => void) => {
  if (!container) return () => {};

  const onClick = (event: MouseEvent) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target = event.target as Element | null;
    const link = target?.closest(CTA_LEAD_LINK_SELECTOR);
    if (!link || !container.contains(link)) return;

    event.preventDefault();
    onOpen();
  };

  container.addEventListener("click", onClick);
  return () => container.removeEventListener("click", onClick);
};
